import { ApiError, RequestAbortError } from '../api/client.js';
import { BleSetupError } from './transport.js';

const NATIVE_ERROR_CODES = new Set([
  'bluetooth_permission_denied',
  'bluetooth_disabled',
  'bluetooth_unavailable',
  'cancelled',
  'disconnected',
  'timeout',
]);

/** User-facing Spanish text for provisioning failures; never echoes remote strings. */
export function bleMessageFor(error: unknown): string {
  if (error && typeof error === 'object' && 'code' in error) {
    const code = (error as { code?: string }).code;
    if (code && NATIVE_ERROR_CODES.has(code)) {
      if (code === 'bluetooth_permission_denied') return 'No has autorizado el Bluetooth. Revisa los ajustes del sistema y vuelve a intentarlo.';
      if (code === 'bluetooth_disabled') return 'Bluetooth apagado. Enciéndelo y vuelve a buscar.';
      if (code === 'bluetooth_unavailable') return 'Bluetooth no disponible. Revisa los ajustes de Bluetooth y los permisos de ASIS, y vuelve a intentarlo.';
      if (code === 'cancelled') return 'Búsqueda cancelada. Puedes volver a buscar cuando quieras.';
      if (code === 'disconnected') return 'El dispositivo se ha desconectado del Bluetooth.';
      if (code === 'timeout') return 'La configuración ha tardado demasiado. Mantén BOOT 10 segundos y vuelve a buscar.';
    }
  }
  if (error instanceof RequestAbortError) return 'La operación se ha detenido. Vuelve a intentarlo desde tu cuenta.';
  if (error instanceof ApiError) {
    if (error.status === 401) return 'Tu sesión ha caducado. Entra de nuevo en ASIS.';
    if (error.status === 403 || error.status === 404) return 'No se ha autorizado la configuración. Revisa el código privado de alta o entra en la cuenta propietaria.';
    if (error.status === 429) return 'Espera un momento antes de volver a intentarlo.';
    return 'No se ha podido verificar la configuración con el servidor. Comprueba la conexión a Internet de la aplicación.';
  }
  if (error instanceof BleSetupError) {
    if (error.code === 'account_changed') return 'El dispositivo ya no está disponible en esta cuenta. Actualiza la lista y comprueba que utilizas la cuenta propietaria.';
    if (error.code === 'invalid_info') return 'El dispositivo necesita firmware compatible y su credencial de fábrica. No se ha enviado ninguna contraseña.';
    if (error.code === 'invalid_receipt') return 'No se ha podido autenticar la respuesta del dispositivo. No damos la configuración por confirmada.';
    if (error.code === 'expired' || error.code === 'timeout') return 'La configuración ha tardado demasiado. Mantén BOOT 10 segundos y vuelve a buscar.';
    if (error.code === 'cancelled') return 'Búsqueda cancelada. Puedes volver a buscar cuando quieras.';
    if (error.code === 'wrong_code') return 'El código no coincide con el de la pantalla de ASIS. Escríbelo de nuevo tal y como aparece; si ha cambiado, usa el nuevo.';
  }
  if ((error as { name?: string })?.name === 'NotFoundError') return 'No se ha seleccionado ningún dispositivo. Mantén BOOT 10 segundos y vuelve a buscar.';
  return 'No se pudo completar la conexión Bluetooth. Acerca el dispositivo, comprueba que Bluetooth está activo y vuelve a buscar.';
}
